"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawAction = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const utils_1 = require("../../utils");
const anchor_1 = require("@project-serum/anchor");
const withdrawObligationCollateral_1 = require("./util/withdrawObligationCollateral");
const constant_1 = require("../../constant");
const refreshReserve_1 = require("./util/refreshReserve");
const withdrawMining_1 = require("./util/withdrawMining");
const redeemReserveCollateral_1 = require("./util/redeemReserveCollateral");
const larixInstructionCollector_1 = require("../../utils/larixInstructionCollector");
const baseAction_1 = require("./util/baseAction");
const account_1 = require("../../utils/account");
class WithdrawAction extends baseAction_1.BaseAction {
    withdraw(collateralAmount, reserve, larixMining, larixObligation) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const allReserve = this.marketData.reserveStates;
            let mining = larixMining === null || larixMining === void 0 ? void 0 : larixMining.state;
            let obligation = larixObligation === null || larixObligation === void 0 ? void 0 : larixObligation.state;
            const redeemReserveDetail = reserve.state;
            const lendingProgramID = this.marketConfig.programId;
            const sourceTokenAccount = this.userInfo.getCollateralTokenAccount(reserve);
            const destinationTokenAccount = this.userInfo.getLiquidityTokenAccount(reserve);
            const larixTransaction = new larixInstructionCollector_1.LarixInstructionCollector(this.wallet);
            const connection = this.connection;
            let sourceAddress;
            if (sourceTokenAccount == undefined) {
                sourceAddress = yield (0, account_1.getOrCreateAssociatedTokenAccount)(connection, larixTransaction.instructions, this.userInfo.publicKey, redeemReserveDetail.info.collateral.mintPubkey, this.userInfo.publicKey);
            }
            else {
                sourceAddress = sourceTokenAccount.pubkey;
            }
            if (mining === undefined) {
                const myMinings = yield this.userInfo.getMiningOfMarket(redeemReserveDetail.info.lendingMarket, lendingProgramID);
                if (myMinings.length > 0) {
                    mining = myMinings[0];
                }
            }
            if (obligation === undefined) {
                const myObligations = yield this.userInfo.getObligationOfMarket(redeemReserveDetail.info.lendingMarket, lendingProgramID);
                if (myObligations.length > 0) {
                    obligation = myObligations[0];
                }
            }
            let hasObligation = false;
            if (obligation != undefined) {
                obligation.info.deposits.map((collateral) => {
                    if (collateral.depositReserve.equals(redeemReserveDetail.pubkey)) {
                        hasObligation = true;
                    }
                });
            }
            if (hasObligation) {
                if (obligation != undefined) {
                    yield (0, withdrawObligationCollateral_1.withdrawObligationCollateral)(connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, obligation, collateralAmount.cmp(new anchor_1.BN(-1)) == 0 ? constant_1.U64_MAX : collateralAmount, sourceAddress, redeemReserveDetail, this.userInfo.publicKey, allReserve, lendingProgramID, this.marketConfig.authorityId);
                    //deal withdraw SOL
                    if (redeemReserveDetail.info.liquidity.mintPubkey.equals(spl_token_1.NATIVE_MINT)) {
                        if (obligation.info.deposits.length + obligation.info.borrows.length >= 4) {
                            let hasLpDeposit = false;
                            obligation.info.deposits.map(deposit => {
                                var _a;
                                (_a = this.marketConfig.lpReserves) === null || _a === void 0 ? void 0 : _a.map(lpReserveConfig => {
                                    if (deposit.depositReserve.equals(lpReserveConfig.reserveId)) {
                                        hasLpDeposit = true;
                                    }
                                });
                            });
                            if (hasLpDeposit) {
                                larixTransaction.newTransaction();
                            }
                        }
                    }
                }
            }
            else {
                yield (0, refreshReserve_1.refreshReserve)(connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, redeemReserveDetail, lendingProgramID);
                yield (0, withdrawMining_1.withdrawMining)(connection, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, 
                // @ts-ignore
                mining.pubkey, sourceAddress, redeemReserveDetail, collateralAmount.cmp(new anchor_1.BN(-1)) == 0 ? constant_1.U64_MAX : collateralAmount, this.userInfo.publicKey, redeemReserveDetail.info.lendingMarket, lendingProgramID, this.marketConfig.authorityId);
            }
            const destinationLiquidityPubkey = yield (0, account_1.findOrCreateAccountByMint)(this.connection, this.userInfo.publicKey, this.userInfo.publicKey, larixTransaction.instructions, larixTransaction.cleanupInstructions, redeemReserveDetail.info.liquidity.mintPubkey, larixTransaction.signers, destinationTokenAccount);
            const withdrawLpPublicKeys = [];
            if (redeemReserveDetail.info.isLP) {
                const withdrawLpAccounts = yield this.withdrawLpAccountProvider(this.userInfo.publicKey, redeemReserveDetail.info.liquidity.params_1);
                if (withdrawLpAccounts.length == 0) {
                    const bridgePoolProgram = yield (0, utils_1.getBridgeProgram)(connection, this.marketConfig);
                    const withdrawLpAccount = web3_js_1.Keypair.generate();
                    larixTransaction.instructions.push(bridgePoolProgram.instruction.initializeWithdrawLpAccount({
                        accounts: {
                            withdrawLpAccount: withdrawLpAccount.publicKey,
                            owner: this.userInfo.publicKey,
                            pool: redeemReserveDetail.info.liquidity.params_1,
                            systemProgram: web3_js_1.SystemProgram.programId
                        }
                    }));
                    larixTransaction.signers.push(withdrawLpAccount);
                    withdrawLpPublicKeys.push(withdrawLpAccount.publicKey);
                    if (obligation) {
                        // Transactions may exceed
                        if (((_a = obligation.info) === null || _a === void 0 ? void 0 : _a.deposits.length) + ((_b = obligation.info) === null || _b === void 0 ? void 0 : _b.borrows.length) >= 4) {
                            larixTransaction.newTransaction();
                        }
                    }
                }
                else {
                    withdrawLpAccounts.map(account => {
                        withdrawLpPublicKeys.push(account.pubkey);
                    });
                }
            }
            yield (0, redeemReserveCollateral_1.redeemReserveCollateral)(connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, sourceAddress, collateralAmount.cmp(new anchor_1.BN(-1)) == 0 ? constant_1.U64_MAX : collateralAmount, this.userInfo.publicKey, redeemReserveDetail, destinationLiquidityPubkey, lendingProgramID, this.marketConfig.authorityId, withdrawLpPublicKeys[0]);
            if (redeemReserveDetail.info.isLP) {
                larixTransaction.newTransaction();
                const bridgePoolProgram = yield (0, utils_1.getBridgeProgram)(this.connection, this.marketConfig);
                const bridgePool = yield (0, utils_1.getBridgePool)(redeemReserveDetail.info.liquidity.params_1, this.connection, this.marketConfig);
                const withdrawLpAccount = withdrawLpPublicKeys[0];
                (_c = this.marketConfig.lpReserves) === null || _c === void 0 ? void 0 : _c.map(lpReserveConfig => {
                    if (redeemReserveDetail.pubkey.equals(lpReserveConfig.reserveId)) {
                        if (bridgePool.isFarm) {
                            //@ts-ignore
                            larixTransaction.instructions.push(bridgePoolProgram.instruction.withdrawFarmLp({
                                accounts: {
                                    pool: redeemReserveDetail.info.liquidity.params_1,
                                    bridgePoolLpSupply: bridgePool.lpSupply,
                                    withdrawAccount: withdrawLpAccount,
                                    owner: this.userInfo.publicKey.toString(),
                                    farmPoolProgramId: lpReserveConfig.farmPoolProgramId,
                                    farmPool: bridgePool.farmPoolId,
                                    farmPoolAuthority: lpReserveConfig.farmPoolAuthority,
                                    farmLedger: bridgePool.farmLedger,
                                    userLpTokenAccount: destinationLiquidityPubkey,
                                    farmPoolLpSupply: lpReserveConfig.farmPoolLpSupply,
                                    rewardAccount: bridgePool.rewardSupply[0],
                                    rewardVault: lpReserveConfig.farmRewardVault,
                                    sysvarClock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                                    rewardAccountB: bridgePool.rewardSupply.length == 1 ? bridgePool.rewardSupply[0] : bridgePool.rewardSupply[1],
                                    rewardVaultB: bridgePool.rewardSupply.length == 1 ? lpReserveConfig.farmRewardVault : lpReserveConfig.farmRewardVaultB
                                }
                            }));
                        }
                        else {
                            larixTransaction.instructions.push(bridgePoolProgram.instruction.withdrawLp({
                                accounts: {
                                    pool: redeemReserveDetail.info.liquidity.params_1,
                                    bridgePoolLpSupply: bridgePool.lpSupply,
                                    withdrawAccount: withdrawLpAccount,
                                    owner: this.userInfo.publicKey,
                                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                                    userLpTokenAccount: destinationLiquidityPubkey,
                                }
                            }));
                        }
                    }
                });
            }
            return larixTransaction;
        });
    }
    withdrawLpAccountProvider(ownerAddress, bridgePoolAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const bridgeProgram = yield (0, utils_1.getBridgeProgram)(this.connection, this.marketConfig), accounts = yield bridgeProgram.account.withdrawLpAccount.all([
                {
                    dataSize: bridgeProgram.account.withdrawLpAccount.size
                },
                {
                    memcmp: {
                        offset: 8,
                        bytes: ownerAddress.toBase58()
                    }
                }
            ]);
            const result = [];
            accounts.map((account) => {
                if (bridgePoolAddress.equals(account.account.poolId)) {
                    result.push({
                        pubkey: account.publicKey,
                        account: null,
                        info: account.account,
                    });
                }
            });
            return result;
        });
    }
}
exports.WithdrawAction = WithdrawAction;
